import { render, staticRenderFns } from "./Grades.vue?vue&type=template&id=573f5bd6&scoped=true&"
import script from "./Grades.vue?vue&type=script&lang=js&"
export * from "./Grades.vue?vue&type=script&lang=js&"
import style0 from "./Grades.vue?vue&type=style&index=0&id=573f5bd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573f5bd6",
  null
  
)

export default component.exports